import { render, staticRenderFns } from "./WishesSampleUpdate.vue?vue&type=template&id=5f137ab7&scoped=true"
import script from "./WishesSampleUpdate.vue?vue&type=script&lang=js"
export * from "./WishesSampleUpdate.vue?vue&type=script&lang=js"
import style0 from "./WishesSampleUpdate.vue?vue&type=style&index=0&id=5f137ab7&lang=css"
import style1 from "./WishesSampleUpdate.vue?vue&type=style&index=1&id=5f137ab7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f137ab7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f137ab7')) {
      api.createRecord('5f137ab7', component.options)
    } else {
      api.reload('5f137ab7', component.options)
    }
    module.hot.accept("./WishesSampleUpdate.vue?vue&type=template&id=5f137ab7&scoped=true", function () {
      api.rerender('5f137ab7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/WishesSampleUpdate.vue"
export default component.exports